import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-footer" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://exoty.com",
  target: "_blank",
  rel: "noopener noreferrer"
}, [
  /*#__PURE__*/_createElementVNode("span", null, " Exoty")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, ". All rights reserved", -1)
const _hoisted_4 = { class: "float-right d-none d-sm-inline-block" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("b", null, "Version", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("strong", null, [
      _createElementVNode("span", null, "Copyright © " + _toDisplayString(_ctx.currentYear), 1),
      _hoisted_2,
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("span", null, ": " + _toDisplayString(_ctx.version), 1)
    ])
  ]))
}